import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'
import postHog from '@metro-fs/analytics-plugin-posthog'

// Initialize analytics and plugins
// Documentation: https://getanalytics.io
const analytics = Analytics({
  app: 'toastyai-web',
  debug: process.env.NODE_ENV !== 'production',
  plugins: [
    googleTagManager({
      containerId: process.env.NEXT_PUBLIC_GTM_ID,
      enabled: true,
    }),
    postHog({
      token: process.env.NEXT_PUBLIC_POSTHOG_API_KEY || '',
      enabled: process.env.NODE_ENV !== 'development',
      options: {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || '',
        debug: process.env.NODE_ENV === 'development',
        persistence: 'memory',
        disable_cookie: true,
      },
    }),
  ],
})

export default analytics
